/**
 * Constantes para el módulo de Calendario
 */

export const CALENDAR_EVENT_TYPES = [
  { value: "OFFICE_VISIT", label: "Visita a oficina", color: "#2e7d32" },
  { value: "MECHANIC_WORKSHOP", label: "Visita a taller", color: "#ed6c02" },
  { value: "MEETING", label: "Reunión", color: "#9c27b0" },
  { value: "LAB_STUDY", label: "Estudio de laboratorio", color: "#d32f2f" },
  { value: "UNIT_DELIVERY", label: "Entrega de unidad", color: "#00838f" },
  { value: "MAINTENANCE", label: "Mantenimiento", color: "#1976d2" },
];

export const STATUS_CONFIG = {
  PENDING: { color: "#FFA500", label: "Pendiente", bgColor: "#FFF3E0" },
  SCHEDULED: { color: "#1976d2", label: "Agendado", bgColor: "#E3F2FD" },
  IN_PROGRESS: { color: "#0288d1", label: "En progreso", bgColor: "#E1F5FE" },
  COMPLETED: { color: "#4CAF50", label: "Completado", bgColor: "#E8F5E9" },
  CANCELLED: { color: "#f44336", label: "Cancelado", bgColor: "#FFEBEE" },
  POSTPONED: { color: "#9E9E9E", label: "Pospuesto", bgColor: "#F5F5F5" },
};

export const WEEK_DAYS = ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"];

export const GRID_TYPE_META = {
  MIP: { label: "MIP", color: "#1D4E89" },
  TICKET: { label: "Ticket", color: "#B45309" },
  NEBULIZACION: { label: "Neb", color: "#0F766E" },
  MICROINYECCION: { label: "Micro", color: "#6D28D9" },
  MOSCA: { label: "Mosca", color: "#3F6212" },
  ABEJA: { label: "Abeja", color: "#A16207" },
  EQUIPO: { label: "Equipo", color: "#334155" },
  CHOQUE: { label: "Choque", color: "#B91C1C" },
  SUPERVISION: { label: "Sup", color: "#0369A1" },
  EVENTUAL: { label: "Evt", color: "#9A3412" },
  OTRO: { label: "Otro", color: "#57534E" },
  OFFICE_VISIT: { label: "Oficina", color: "#2e7d32" },
  MECHANIC_WORKSHOP: { label: "Taller", color: "#ed6c02" },
  MEETING: { label: "Reunión", color: "#9c27b0" },
  LAB_STUDY: { label: "Lab", color: "#d32f2f" },
  UNIT_DELIVERY: { label: "Entrega", color: "#00838f" },
  MAINTENANCE: { label: "Mant", color: "#1976d2" },
};

export const FILTER_TYPES = {
  TECHNICIAN: "technician",
  ZONE: "zone",
};

export const DEFAULT_EDIT_FORM = {
  technicians: [],
  date: "",
  hour: "",
  type: "",
  title: "",
  eventType: "",
  location: "",
  status: "PENDING",
  notes: "",
};

